import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Master APIs
//TODO: Brand APIs
//  Brand Create
export const createBrandAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-brand`, data,headers);
};
//  Brand Update
export const updateBrandAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-brand`, data,headers);
};
//  Brand List
export const listBrandAPI = async () => {
  const headers = createHeaders()   
  return await axios.get(`${BASE_URL}list-brand`, headers);
};

//TODO: Category APIs
//  Category Create
export const createCategoryAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-category`, data,headers);
};
//  Category Update
export const updateCategoryAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-category`, data,headers);
};
//  Category List
export const listCategoryAPI = async () => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-category`, headers);
};
//TODO: Unit APIs
//  Unit Create
export const createUnitAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-unit`, data,headers);
};
//  Unit Update
export const updateUnitAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-unit`, data,headers);
};
//  Unit List
export const listUnitAPI = async () => {
  const headers = createHeaders()   
  return await axios.get(`${BASE_URL}list-unit`, headers);
};
//TODO: Disease APIs
//  Disease Create
export const createDiseaseAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-disease`, data,headers);
};
export const createGroupAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-test-category`, data,headers);
};
export const createPackageAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-test-package`, data,headers);
};
export const createPackageLabAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-lab-package`, data,headers);
};
export const createLabPackageAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-lab-package-test`, data,headers);
};
export const craeteLabBoy = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-lab-boy`, data,headers);
};
export const createSubGroupAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-test-sub-category`, data,headers);
};
export const createSubGroupLabAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-test-sub-group`, data,headers);
};
export const createPackageTestAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-packages-test`, data,headers);
};
export const createLabTest = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}add-lab-test`, data,headers);
};
export const createTestDetailsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}add-test-detail`, data,headers);
};
export const createPharmacyStore = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-pharmacy-store`, data,headers);
};
export const craeteHospitalAdditional = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}upsert-hospital-service-admin`, data,headers);
};
export const createPharmacyProfile = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-pharmacy-profile`, data,headers);
};
export const craeteHospitalProfile = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}upsert-hospital-profile-admin`, data,headers);
};
export const createPharmacyAdditopnalStore = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-pharmacy-owner`, data,headers);
};
export const createPharmacyMedicineStore = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-pharmacy-bank-detail`, data,headers);
};

//  Disease Update
export const updateDiseaseAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-disease`, data,headers);
};
export const updateGroupAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-test-category`, data,headers);
};
export const updatePackageAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-test-package`, data,headers);
};
export const updatePackageLabAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-lab-package`, data,headers);
};
export const updateLabPackageAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-lab-package-test`, data,headers);
};
export const updateLabBoy = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-lab-boy`, data,headers);
};
export const updateSubGroupAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-test-sub-category`, data,headers);
};
export const updateSubLabGroupAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-test-sub-group`, data,headers);
};
export const updatePackageTestAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-packages-test`, data,headers);
};
export const updateLabTestAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}admin-update-test`, data,headers);
};
export const updateTestDetailsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-test-detail`, data,headers);
};
//  Disease List
export const listDiseaseAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}get-disease`, data, headers);
};
export const listGroupAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}test-category-list`, data, headers);
};
export const listSubGroupAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}test-sub-category-list`, data, headers);
};export const listLabSubGroupAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}sub-group-test-list-lab`, data, headers);
};
export const listPackageAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}packages-test-list`, data, headers);
};
export const listLabPackageAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}packages-labbbtest-list`, data, headers);
};
export const getListPAckageTestAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}labs-packages-tests`, data, headers);
};
export const getLabBoyList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-boy-list`, data, headers);
};
export const uploadLabReportAPI = async (data) => {
  const headers = createFormHeaders();
  return await axios.post(`${BASE_URL}upload-lab-report`, data, headers);
};
// export const assignSampleCollection = async (data) => {
//   const headers = createHeaders()   
//   return await axios.post(`${BASE_URL}assign-sample-collect`, data, headers);
// };
export const assignSampleCollection = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}assign-sample-collect`, data, headers);
};
export const listTestDetailsAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}test-detail-list`, data, headers);
};
export const listLabTestAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}test-detail-list-lab`, data, headers);
};

// export const adminTestListAPI = async (data) => {
//   const headers = createFormHeaders()   
//   return await axios.post(`${BASE_URL}admin-test-list`, data, headers);
// };
export const adminTestListAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}admin-test-list`,  headers);
};

export const adminCategoryDDAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}testcategory-list-dd`,  headers);
};

// export const adminSubCategoryDDAPI = async (data) => {
//   const headers = createHeaders()   
//   return await axios.post(`${BASE_URL}sub-group-test-list-lab`,  headers);
// };
export const adminSubCategoryDDAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}sub-category-list-dd`, data,headers);
};
export const getHealthConcernAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}get-health-concern`,data, headers);
};
export const updateHealthConcern = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-health-concern`,data, headers);
};
export const createHealthConcern = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-health-concern`,data, headers);
};
//TODO: Product Type APIs
//  Product Type Create
export const createProductTypeAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-qualification`, data,headers);
};

//  Product Type Update
export const updateProductTypeAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-product-type`, data,headers);
};
//  Product Type List
export const listProductTypeAPI = async () => {
  const headers = createHeaders()   
  return await axios.get(`${BASE_URL}list-product-type`, headers);
};
//TODO: Ingredient APIs
//  Ingredient Create
export const createIngredientAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-ingredient`, data,headers);
};
//  Ingredient Update
export const updateIngredientAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-ingredient`, data,headers);
};
//  Ingredient List
export const listIngredientAPI = async () => {
  const headers = createHeaders()   
  return await axios.get(`${BASE_URL}list-ingredient`, headers);
};


// SPecialization APi
export const createSpecialization = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-specialization`, data,headers);
};
export const getSpecialization = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}get-specialization`, data,headers);
};
export const updateSpecialization = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-specialization`, data,headers);
};
//Qualification Api 
export const createQualification = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-qualification`, data,headers);
};
export const listQualificationAPI= async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-qualification`, data,headers);
};
export const updateQualification = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-qualification`, data,headers);
};

export const qualificationList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}qualification-list-dd`, data,headers);
};
export const deleteQualification = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-qualification`, data,headers);
};
// Laboratory Api
export const getLabCategory = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-lab-category`, data,headers);
};
export const updateLabCategory = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-lab-category`, data,headers);
};

export const updatePharmacyAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-pharmacy`, data,headers);
};
export const craetepharmacy = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}createee-pharmacy`, data,headers);
};
export const updatePromotion = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-promotion`, data,headers);
};
export const updatePackage = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-test-package`, data,headers);
};
export const updateLab = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-test-status`, data,headers);
};
export const createLabCategory = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-lab-category`, data,headers);
};
export const createPromotion = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-promotion`, data,headers);
};
export const createPackage = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}add-test-package`, data,headers);
};
export const deleteLabCategory = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-lab-category`, data,headers);
};
export const deletePackageAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-test-package`, data,headers);
};
export const deleteLabPackageAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-lab-package`, data,headers);
};
export const deleteLapProfile = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-test-profile`, data,headers);
};
export const deleteTestCategory = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-test-category`, data,headers);
};
export const deleteTestSubCategory = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-test-sub-category`, data,headers);
};
export const deleteTestLabSubCategory = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-test-sub-group`, data,headers);
};
export const deletePackageTest = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-packages-test`, data,headers);
};
export const deleteLabTest = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}admin-delete-test`, data,headers);
};
export const deleteTestDetails = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-test-detail`, data,headers);
};
//User APi
export const getUserListAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-user-profiles`, data,headers);
};
export const UserDashboardAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}user-dashboard`, data,headers);
};
//User APi
export const createUserAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-user-profile-admin`, data,headers);
};
//User APi
export const updateUserAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-user-profile-admin`, data,headers);
};
//User APi
export const getZipDetailsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-state-district`, data,headers);
};

export const getDoctorsList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-doctor-list`, data,headers);
};
export const  getDoctorDetailsList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-doctor-details`, data,headers);
};
// export const  createCategory = async (data) => {
//   const headers = createHeaders()   
//   return await axios.post(`${BASE_URL}create-category`, data,headers);
// };

//  promotion
export const  getPromotionListAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}promotion-list`, data,headers);
};
export const  getPackageListAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}test-package-list`, data,headers);
};
export const  getPackageAPIList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}admin-package-list`, data,headers);
};
export const  getPackageLabList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}package-list-lab`, data,headers);
};
//  promotion
export const  AddTopDoctorsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-selected-doctor`, data,headers);
};
//  promotion
export const  getDoctorAppointmentsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}appointment-list-admin`, data,headers);
};
export const getTestList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-test-list`, data, headers);
};
export const getTestListsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}admin-test-list`, data, headers);
};
export const getLabProfileList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}test-profile-list`, data, headers);
};
export const uploadFIle = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}upload`, data, headers);
};
export const uploadTestCatalog = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}lab-test`, data, headers);
};
export const uploadTestPackageCatalog = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}lab-package-test-list`, data, headers);
};
export const uploadPackageCatalogAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}lab-package`, data, headers);
};
export const uploadLabTestCatalog = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}lab-sub-group`, data, headers);
};
export const createTestAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-lab-test`, data,headers);
};
export const addTestProfile = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}add-test-profile`, data,headers);
};
export const updateTestAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-lab-test`, data,headers);
};
export const updateLabProfileAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-test-profile`, data,headers);
};
export const getAddressDetailGmailAPI = async (data) => {
  const headers = createFormHeaders()   
  // return await axios.get(`http://192.168.23.96:9000/api/gmail-address-detail?input=${data}`);
  return await axios.get(`${BASE_URL}gmail-address-detail?input=${data}`);
};
export const getAddressListGmailAPI = async (data) => {
  const headers = createFormHeaders()   
  // return await axios.get(`http://192.168.23.96:9000/api/gmail-address?input=${data}`);}
  return await axios.get(`${BASE_URL}gmail-address?input=${data}`);}